import React, { useEffect } from 'react';
import { Card, Row, Button, Col, Form } from 'react-bootstrap';
import { ErrorMessage, Field, Formik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { createNewBiomeApi } from './biomeSlice';
import { useNavigate } from 'react-router-dom';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';

const createSchema = Yup.object().shape({
    biome_name: Yup.string().required(),
});

function BiomeCreate() {
    const { apiValidationErrors } = useSelector((state) => state.apiValidationError);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        return () => {
            dispatch(clearApiValidationErrors());
        };
    }, []);

    const formSubmit = (values, formikBag) => {
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        dispatch(createNewBiomeApi({ navigate, values, formikBag }));
    };

    return (
        <Card>
            <Card.Body>
                <Formik
                    initialValues={{
                        biome_name: '',
                    }}
                    validationSchema={createSchema}
                    onSubmit={async (values, formikBag) => {
                        const submitValues = JSON.parse(JSON.stringify(values));
                        formSubmit(submitValues, formikBag);
                    }}
                >
                    {({ isSubmitting, handleSubmit }) => (
                        <Form
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Row
                                sm={12}
                                className="justify-content-center"
                            >
                                <Col sm={3}>
                                    <div className="form-group">
                                        <Field
                                            name="biome_name"
                                            disabled={isSubmitting}
                                            className="form-control mt-3"
                                            placeholder="Biome name"
                                        />
                                        <ErrorMessage
                                            component="div"
                                            className="invalid-feedback d-block"
                                            name="biome_name"
                                        />
                                        <div className={`form-main`}>
                                            {apiValidationErrors.length > 0 && (
                                                <div
                                                    className="py-1"
                                                    style={{ color: 'red' }}
                                                >
                                                    {apiValidationErrors[0]}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={1}>
                                    <div className="form-group">
                                        <Button
                                            className="font-bolder w-100 btn btn-block mt-3 bg-info border border-info"
                                            type="submit"
                                            disabled={isSubmitting}
                                        >
                                            Create
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </Card.Body>
        </Card>
    );
}

export default BiomeCreate;
